import React from 'react';

export const copyText = (ref: React.MutableRefObject<HTMLTextAreaElement | null>): boolean => {
  window.getSelection()?.removeAllRanges();
  const elem = ref.current;
  try {
    if (!elem) throw new Error('elem not found');
    elem.focus();
    elem.select();
    // TODO(johnverrone): Migrate to new Clipboard API https://developer.mozilla.org/en-US/docs/Web/API/Clipboard
    if (document.execCommand('copy')) {
      return true;
    } else {
      throw new Error("Failed to execCommand('copy')");
    }
  } catch (e) {
    console.warn(`Failed to copy to clipboard: ${e}`);
    return false;
  }
};
